import React, { useContext } from "react";

// Material UI imports

import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";

// components
import AddClassPropertiesHeader from "./AddClassFormPropertiesHeader";
import AddClassPropertiesTable from "./AddClassPropertiesTable";

// Global state
import { StateContext } from "../../AppStateContext.js";

// Styling
import "./style.scss";

const AddClassFormProperties = ({ setIsAddPropertyModalOpen }) => {
  const state = useContext(StateContext);

  return (
    <>
      <AddClassPropertiesHeader />
      <div id="addClassPropertyTableDiv">
        <TableContainer
          component={Paper}
          className={
            state.theme === "dark"
              ? "__addClassPropertyTableContainer __addClassPropertyTableContainerDark"
              : "__addClassPropertyTableContainer __addClassPropertyTableContainerLight"
          }
        >
          <AddClassPropertiesTable />
        </TableContainer>
      </div>
    </>
  );
};

export default AddClassFormProperties;
